import React from "react";
import { useTranslation } from "react-i18next";

import { ConfirmationAlert } from "../../../../../cargotic-webapp-component";

const WarehouseDeleteConfirmationAlert = ({
  isOpen,
  onClose,
  onSubmit
}) => {
  const { t } = useTranslation();

  return (
    <ConfirmationAlert
      title={t("webapp:settings.title.deleteWarehouse")}
      content={t("webapp:settings.prompt.delete-warehouse")}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
};

export default WarehouseDeleteConfirmationAlert;
